
/**
 *
 * @param {node} element the element to observe
 * @param {function} observerCallback callback to call
 * @param {object} observerOptions options for the observer
 * @param {node} rootElement root element of observer
 */

export default function observeElement(element, observerCallback, observerOptions = {}) {
  const observer = new IntersectionObserver(observerCallback, {
    threshold: observerOptions?.threshold || new Array(101).fill(0).map((v, i) => i * 0.01),
    ...observerOptions,
  })
  observer.observe(element)
  return observer
}
